exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* \"Manually pinned\" indicator for an edited row — intentionally NOT .form-error, which is\n   reserved for real validation errors (the UNALLOCATED cells) and blocks the timecard from saving. */\n.allocation-edited[data-v-21bb2ef0] {\n    background-color: #fff3cd;\n    border-color: #ffe08a;\n}\n", ""]);

// exports
